<template>
  <course-imgs-temp :img-urls="imgUrls"></course-imgs-temp>
</template>

<script>
import CourseImgsTemp from '@/components/puppetComponent/CourseImgsTemp'
export default {
  data () {
    return {
      imgUrls: [
        '/upaiyun/Sys/20190724/5257082679367319720.png',
        '/upaiyun/Sys/20190724/5264787945405773164.png',
        '/upaiyun/Sys/20190724/4918452267794908622.png'
      ]
    }
  },
  components: { CourseImgsTemp }
}
</script>
